var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal_center"},[_c('div',{staticClass:"warp1200 fix"},[_c('PersonalCenterMenu',{attrs:{"activeIndex":2}}),_c('div',{staticClass:"f-fr center_right"},[_c('coupon-list',{ref:"list",attrs:{"isExpired":_vm.isExpired}}),_c('promo-cruise')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }